/**
 * Migrated from:
 * nm/mvc/ValidatedFormView.js
 * nm/mvc/Validated.js
 * nm/form.js
 */
import {Rule} from '@cesium133/forgjs';

const ValidationRules = {
  city: new Rule({
    type: 'string',
    match: /^(([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]){2,})(([.,]){0,1})?(([ -]){0,1}?(([(/]){0,1})([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ,.]){2,})?(([)/]){0,1})?(([ -]){0,1}?(([(/]){0,1})([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ,.]){2,})?(([)/]){0,1})?(([ -]){0,1}?(([(/]){0,1})([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ,.]){2,})?(([)/]){0,1})?$/,
  }),
  customercardActivation: new Rule({
    type: 'string',
    match: /(^31[0-9]{16})$/,
  }),
  email: new Rule({
    type: 'email',
    match: /[^\s@]+@[^\s@]+\.[^\s@]+/,
  }),
  teamName: new Rule({
    type: 'string',
    match: /^[0-9a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]{2,}[- .,`()0-9a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]*$/,
  }),
  forename: new Rule({
    type: 'string',
    match: /^[a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]{2,}[- .,`()a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]*$/,
  }),
  lastname: new Rule({
    type: 'string',
    match: /^[a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]{2,}[- .,`()a-zA-ZäöüÄÖÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ]*$/,
  }),
  optional: new Rule({
    type: 'string',
    match: /(?![\<\>\|\{\}\[\]\'\*\"\\\$])/,
  }),
  phone: new Rule({
    type: 'string',
    match: /^([\d]{6,24})$/,
  }),
  required: new Rule({
    type: 'string',
    notEmpty: true,
  }),
  checked(fieldName) {
    return new Rule({
      type: 'string-int',
      custom: function isChecked() {
        const $input = ValidatedFormView.getInput(fieldName);
        return $input.prop('checked');
      }
    })
  },
  maxLength(stringLength) {
    return new Rule({
      type: 'string',
      maxLength: parseInt(stringLength),
    });
  },
  street_de: new Rule({
    type: 'string',
    match: /^([a-zA-ZäÄöÖüÜß0-9ńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,}[a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,})|([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,}[a-zA-ZäÄöÖüÜß0-9ńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,})(([.]){0,1})?(([ -]){0,1}?(([(/]){0,1})([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){3,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){3,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){3,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜß]){3,})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){3,})?([ ])([\d]){1,4}(([a-zA-Z]){0,2})([/-]([\d]{1,2})([a-zA-Z]{1})?)?([/-]([\d]{1,4})([a-zA-Z]{1})?)?$/,
  }),
  street_at: new Rule({
    type: 'string',
    match: /^([a-zA-ZäÄöÖüÜß0-9ńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,}[a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,})|([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,}[a-zA-ZäÄöÖüÜß0-9ńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']{1,})(([.]){0,1})?(([ -]){0,1}?(([(/]){0,1})([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){1,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){3,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){1,})?(([.]){0,1})?(([)/]){0,1})?(([ -]){0,1}([a-zA-ZäÄöÖüÜß]){3,})?(([ -]){0,1}([a-zA-ZäÄöÖüÜßńźżłóśćąęãõçëñæøåðýøèéàáâôœàèìùţăĺäôěřůıİğőűŵŷâŃŹŻŁÓŚĆĄĘÃÕÇËÑÆØÅÐÝØÈÉÀÁÂÔŒÀÈÌÙŢĂĹÄÔĚŘŮIİĞŐŰŴŶÂ']){1,})?([ ])([\d]){1,4}(([a-zA-Z]){0,2})([/-]([\d]{1,2})([a-zA-Z]{1})?)?([/-]([\d]{1,4})([a-zA-Z]{1})?)?$/,
  }),
  zip_de: new Rule({
    type: 'string',
    match: /^([\d]{5})$/,
  }),
  zip_at: new Rule({
    type: 'string',
    match: /^([\d]{4})$/,
  }),
  zip_nl: new Rule({
    type: 'string',
    match: /^[0-9]{4}\s[A-Z]{2}$/,
  }),
  // Campaign specific
  dateAge({minAge, baseDate}) {
    const date = baseDate ? new Date(baseDate) : new Date();
    const currentYear = date.getFullYear();
    const currentDay = date.getDate();
    const targetYear = currentYear - minAge;

    date.setFullYear(targetYear);
    // Set tomorrow, since the date of birth may be today
    date.setDate(currentDay + 1);

    return new Rule({
      type: 'date',
      before: date,
    });
  },
  relation: new Rule({
    type: 'string-int',
    min: 1,
    max: 6,
  }),
};


export default class ValidatedFormView {
  constructor(options) {
    this.$form = null;
    this.validations = [];
    this.liveValidations = [];

    Object.assign(this, options);

    this.attachValidations();
    this.attachLiveValidations();

    $(this.$form).on('submit', this.handleSubmitEvent.bind(this));
  }

  attachValidations() {
    Object.keys(this.validations).forEach((fieldName) => {
      const rules = this.validations[fieldName];
      const inputType = ValidatedFormView.getInputType(fieldName);
      let eventType = 'focusout';

      if (['file', 'checkbox'].indexOf(inputType) >= 0) {
        eventType = 'change';
      }

      this.attachEvent(eventType, fieldName, rules);
    });
  }

  attachLiveValidations() {
    Object.keys(this.liveValidations).forEach((fieldName) => {
      const config = this.liveValidations[fieldName];
      const events = Object.keys(config);

      events.forEach((event) => {
        const eventConfig = config[event][0];
        const handler = typeof eventConfig === 'function' ? eventConfig : false;

        $(this.$form).on(event, ValidatedFormView.getInputSelector(fieldName), handler);
      });
    });
  }

  handleSubmitEvent(event) {
    const allValid = this.validateAllFormFields();
    if (allValid) {
      return this.doSubmit(event);
    } else {
      this.scrollToErrorMessage();
      return this.cancelEvent(event);
    }
  }

  doSubmit(event) {
    return true;
  }

  cancelEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }

  attachEvent(event, fieldName, rules) {
    const $input = ValidatedFormView.getInput(fieldName);
    $input.on(event, () => {
      this.validateField(fieldName, rules);
    });
  }

  scrollToErrorMessage() {
    var $errorMessages = $('.form-alert, .has-error');
    if ($errorMessages.length) {
      var headerHeight = $('#header-wrapper').height();
      $('html,body').animate({
        scrollTop: $errorMessages.first().offset().top - headerHeight,
      }, 1000);
    }
  }

  /**
   * @return {boolean} allValid
   */
  validateAllFormFields() {
    let validationResults = [];

    for (const fieldName in this.validations) {
      if (this.validations.hasOwnProperty(fieldName)) {
        const rules = this.validations[fieldName];
        validationResults.push(this.validateField(fieldName, rules));
      }
    }

    const allValid = validationResults.every((result) => result === true);
    return allValid;
  }

  /**
   * @param {string} fieldName
   * @param {array} rules
   * @return {boolean} allValid
   */
  validateField(fieldName, rules) {
    const $input = ValidatedFormView.getInput(fieldName);
    const isOptional = this.isFieldOptional(fieldName);
    this.trimInputValue($input);

    let value = $input.val();
    const originValue = value;
    let validationResults = [];

    if (Array.isArray(rules)) {
      rules.forEach((rule) => {
        let ruleParameter = '';

        if (rule.hasOwnProperty('func') && this.hasOwnProperty(rule.func) && typeof this[rule.func] === 'function') {
          rule = this[rule.func]();
        }
        if (rule.hasOwnProperty('rule') && rule.hasOwnProperty('param')) {
          ruleParameter = rule['param'];
          rule = rule['rule'];
        }

        if (ValidationRules.hasOwnProperty(rule) === false) {
          throw new Error(`Validation rule "${rule}" is not defined`);
        }

        if (rule.indexOf('date') >= 0) {
          // Transform value for date evaluation
          const [day, month, year] = value.split('.');
          const date = new Date();

          date.setFullYear(year);
          date.setMonth(month - 1);
          date.setDate(day);

          value = date;
        }

        let validationResult;

        if (ruleParameter) {
          validationResult = ValidationRules[rule](ruleParameter).test(value);
        } else {
          validationResult = ValidationRules[rule].test(value);
        }

        validationResults.push(validationResult);
      });
    } else {
      throw new Error(`Validation rules for "${fieldName}" are not an array`);
    }

    const allValid = validationResults.every((result) => result === true) || (isOptional && originValue === '');
    if (allValid) {
      this.handleSuccess(fieldName);
    } else {
      this.handleError(fieldName);
    }

    return allValid;
  }

  static getInput(fieldName) {
    return $(this.getInputSelector(fieldName));
  }

  static getInputSelector(fieldName) {
    return `[name="${fieldName}"]:not([type="hidden"])`;
  }

  static getInputType(fieldName) {
    return $(this.getInputSelector(fieldName)).attr('type');
  }

  isFieldOptional(fieldName) {
    let isOptional = false;
    if (this.validations.hasOwnProperty(fieldName)) {
      const rules = this.validations[fieldName];
      isOptional = rules.indexOf('optional') >= 0;
    }
    return isOptional;
  }

  handleSuccess(fieldName) {
    const $input = ValidatedFormView.getInput(fieldName);
    const isOptional = this.isFieldOptional(fieldName);
    const value = $input.val();
    const $formGroups = $input.closest('.form-control-holder, .form-group');

    $formGroups.each((index, formGroup) => {
      const $formGroup = $(formGroup);

      if (value !== '') {
        $formGroup.removeClass('has-error');
        $('.validatinator-error', $formGroup).css('display', 'none');
        $('.validatinator-success', $formGroup).css('display', 'block');
        $input.addClass('has-value');
      } else if (isOptional && value === '') {
        $formGroup.removeClass('has-error has-success');
        $('.validatinator-error, .validatinator-success', $formGroup).css('display', 'none');
        $input.removeClass('has-value');
      }
    });
  }

  handleError(fieldName) {
    const $input = ValidatedFormView.getInput(fieldName);
    const $formGroups = $input.closest('.form-control-holder, .form-group');

    $formGroups.each((index, formGroup) => {
      const $formGroup = $(formGroup);

      $formGroup.removeClass('has-success');
      $formGroup.addClass('has-error');
      $('.validatinator-error', $formGroup).css('display', 'block');
      $('.validatinator-success', $formGroup).css('display', 'none');
    });

    $input.removeClass('has-value');
  }

  trimInputValue($input) {
    if (!$input.length) {
      return;
    }

    const trimmedValue = $input.val().trim();
    const isPasswordInput = [ // TODO: Update for TYPO3 if necessary
      'logonPassword',
      'logonPasswordVerify',
    ].indexOf($input.attr('name')) >= 0;
    const isTypeFile = $input.attr('type') === 'file';

    if (isPasswordInput || isTypeFile) {
      // Don't trim passwords
      return;
    }

    /*
     * First reset input value, since in Chromium [type="email"] returns an
     * already trimmed value.
     */
    $input.val('');
    $input.val(trimmedValue);
  }
}
